/* eslint-disable prefer-destructuring */

import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { config } from 'utils/config';
import { callApi, formatDate } from 'utils/utils';
import { Column } from 'primereact/column';
import FieldButton from 'components/Controls/FieldButton/FieldButton';
import FieldDataTable from 'components/Controls/FieldDataTable/FieldDataTable';
import ITAssetsDetails from './ITAssetsDetails';
import ITAssetsAssign from './ITAssetsAssign';
import ITAssetsDisable from './ITAssetsDisable';
import { Dialog } from 'primereact/dialog';
import { Sidebar } from 'primereact/sidebar';

const ITAssets = (props) => {
  const {t, i18n} = useTranslation(['it', 'common']);

  const [assets, setAssets] = useState([]); // IT Assets
  const [filters, setFilters] = useState({}); // Filters
  const [showDetails, setShowDetails] = useState(false); // Show details bar
  const [showAssign, setShowAssign] = useState(false); // Show assign dialog
  const [showDisable, setShowDisable] = useState(false); // Show disable dialog
  const [tableRow, setTableRow] = useState(null); // Details table data

  useEffect(() => {
    getAssets();
  }, [props.filters])

  // Get list of assets with filters
  const getAssets = () => {
    const filters = props.filters;

    const urlWebService = `${config.UrlApiProject}IT/GetITAssets`;
    
    const paramsService = {};
    if (props.filters !== undefined && props.filters !== null) {
      paramsService.IdITEquipo = filters.IdITEquipo;
      paramsService.ClaTipoEquipo = filters.ClaTipoEquipo;
      paramsService.ClaMarcaEquipo = filters.ClaMarcaEquipo;
      paramsService.NomProveedor = filters.NomProveedor;
      paramsService.ModeloEquipo = filters.ModeloEquipo;
      paramsService.SerialNumber = filters.SerialNumber;
      paramsService.IdOrdenCompraRef = filters.IdOrdenCompraRef;
      paramsService.ClaUsuarioAsignado = filters.AssignedUser;
      paramsService.ClaUbicacion = filters.ClaUbicacion;
      paramsService.AssignedTo = filters.AssignedTo;
      paramsService.ClaADPEmployee = filters.ClaADPEmployee;
      paramsService.MacAddress = filters.MacAddress;
    }

    console.log(paramsService);

    callApi(urlWebService, 'POST', paramsService, (response) => {
      setAssets(response.data.assets);
    });
  }

  // Show the details
  const onClickDetails = (row) => {
    setShowDetails(true);
    setTableRow(row);
  }

  // Assign a user
  const onClickAssign = (row) => {
    setTableRow(row);
    setShowAssign(true);
  }

  // Disable an asset
  const onClickDisable = (row) => {
    setTableRow(row);
    setShowDisable(true);
  }

  // Assign Dialog close
  const onHideAssign = () => {
    setShowAssign(false);
    getAssets();
  }

  // Disable Dialog close
  const onHideDisable = () => {
    setShowDisable(false);
    getAssets();
  }

  const onHideDetails = () => {
    setShowDetails(false);
    getAssets();
  }

  // Table purchase date
  const purchaseDateTemplate = (row) => {
    return (
      <>
        {row.FechaCompra !== null && row.FechaCompra !== undefined ? (
          <span>{formatDate(row.FechaCompra)}</span>
        ) : <></>}
      </>
    )
  }

  // Table options
  const optionsTemplate = (row) => {
    return (
      <>
        <FieldButton
          name='details'
          icon='pi pi-list'
          className='p-button-rounded'
          onClick={() => {onClickDetails(row)}}
          tooltip={t('it:Details')}
        />
      </>
    )
  }

  return (
    <>
      <FieldDataTable
        value={assets}
        scrollable
      >
        <Column header={t('it:ID')} sortable field='IdITEquipo' headerStyle={{ width: '60px' }} />
        <Column header={t('it:Equipment')} sortable field='NomTipoEquipo' headerStyle={{ width: '155px' }} />
        <Column header={t('it:Brand')} sortable field='NomMarcaEquipo' headerStyle={{ width: '125px' }} />
        <Column header={t('it:SerialNumber')} sortable field='SerialNumber' headerStyle={{ width: '145px' }} />
        <Column header={t('it:MACAddress')} sortable field='MacAddress' headerStyle={{ width: '145px' }} />
        <Column header={t('it:Model')} sortable field='ModeloEquipo' headerStyle={{ width: '225px' }} />
        <Column header={t('it:Location')} sortable field='Location' headerStyle={{ width: '150px' }} />
        <Column header={t('it:Building')} sortable field='Building' headerStyle={{ width: '150px' }} />
        <Column header={t('it:AssignedTo')} sortable field='AssignedTo' headerStyle={{ width: '135px' }} />
        <Column header={t('it:Employee')} sortable field='Employee' headerStyle={{ width: '275px' }} />
        <Column body={optionsTemplate} />
      </FieldDataTable>
      {/* <Sidebar
        className='p-sidebar-lg'
        position='right'
        baseZIndex={1000000}
        visible={showDetails}
        onHide={() => onHideDetails()}
        blockScroll={true}
        showCloseIcon={true}
        dismissable={true}
      >
        <ITAssetsDetails visible={showDetails} selectedAsset={tableRow} onHide={() => onHideDetails()} />
      </Sidebar> */}
      <Dialog
        visible={showDetails}
        onHide={() => onHideDetails()}
        header={t('it:Details')}
        maximized
        modal
        blockScroll={true}
      >
        <ITAssetsDetails visible={showDetails} selectedAsset={tableRow} onHide={() => onHideDetails()} />
      </Dialog>
    </>
  )
}

export default ITAssets;